import { showVarianceHistoryDetailsModal } from "@actions/modals";
import collections from "@api/collections";
import DownloadButton from "@buttons/DownloadButton";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import DetailsButton from "@shared/DetailsButton";
import React from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Grid } from "semantic-ui-react";

class VarianceHistory extends React.Component {
  state = {
    detailsLoading: false,
    loading: false,
    options: [],
    grid: {
      headerDef: [],
      rowDef: [],
      data: [],
    },
    activeRow: {
      optionShowDetails: false,
    },
    selectedOption: null,
  };

  componentDidMount() {
    this.getOptions();
  }

  componentDidUpdate(prevProps) {
    const { siteId, operator } = this.props;
    if (siteId !== prevProps.siteId || operator !== prevProps.operator) {
      this.getOptions();
    }
  }

  getOptions = () => {
    const { siteId, operator } = this.props;
    if (siteId) {
      this.setState({ loading: true }, () => {
        collections.getVarianceHistoryOptions(operator, siteId).then(
          (options) => {
            const selectedOption =
              this.props.selectedVarianceType ||
              options.find((option) => option.isDefault).value ||
              options[0].value;
            this.setState(
              { options, selectedOption: selectedOption, loading: false },
              () => this.handleRefresh(),
            );
          },
          () => this.setState({ loading: false }),
        );
      });
    }
  };

  handleRefresh = () => {
    const { siteId, operator } = this.props;
    this.setState({ loading: true }, () => {
      collections
        .getVarianceHistory(operator, siteId, this.state.selectedOption)
        .then(
          (result) => {
            this.setState({ loading: false, grid: result.grid });
          },
          () => this.setState({ loading: false }),
        );
    });
  };

  onRowClick = (activeRow) => this.setState({ activeRow });

  onDetailsClick = () => {
    const { activeRow } = this.state;
    const { operator } = this.props;

    this.setState({ detailsLoading: true }, () => {
      collections.getVarianceHistoryByMin(operator, activeRow.min).then(
        (result) =>
          this.setState({ detailsLoading: false }, () => {
            this.props.showVarianceHistoryDetailsModal(
              result,
              async () => this.onDetailsClick(),
              async () => this.handleRefresh(),
            );
          }),
        () => this.setState({ detailsLoading: false }),
      );
    });
  };

  onExportClick = () => {
    const { siteId, operator } = this.props;
    this.setState({ exportLoading: true }, () => {
      collections
        .getVarianceHistoryExport(operator, siteId, this.state.selectedOption)
        .then(
          (response) =>
            this.setState({ exportLoading: false }, () =>
              handleDownload(response),
            ),
          () => this.setState({ exportLoading: false }),
        );
    });
  };

  render() {
    const {
      options,
      selectedOption,
      activeRow,
      loading,
      detailsLoading,
      exportLoading,
    } = this.state;
    const { headerDef, rowDef, data } = this.state.grid;
    const { siteId } = this.props;

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column>
            <DownloadButton
              loading={exportLoading}
              onClick={this.onExportClick}
            />
            <Dropdown
              selection
              options={options}
              name="options"
              value={selectedOption}
              onChange={(event, { value }) =>
                this.setState({ selectedOption: value })
              }
              className="mr-1"
            />
            <Button
              icon="refresh"
              disabled={loading || !siteId || this.state.options.length < 1}
              onClick={this.handleRefresh}
              positive
              floated="right"
              content="Refresh"
            />
            <DetailsButton
              loading={detailsLoading}
              onClick={this.onDetailsClick}
              disabled={
                !activeRow.optionShowDetails ||
                loading ||
                this.state.options.length < 1
              }
              floated="right"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={headerDef}
              data={data}
              rowDef={rowDef}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(null, { showVarianceHistoryDetailsModal })(
  VarianceHistory,
);
